import { apiErrorMessage, apiErrorStatus } from '../../../../../utils/apiError.ts';

const DM_UNAVAILABLE_STATUS = 502;

// A 422 carries DM's own readable reasons, which apiErrorMessage surfaces as-is.
export function dmErrorMessage(error: unknown, fallback: string): string {
    if (apiErrorStatus(error) === DM_UNAVAILABLE_STATUS) {
        return 'DM is unavailable right now. Try again later.';
    }
    return apiErrorMessage(error, fallback);
}
